export default {
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    delete: '削除',
    edit: '編集',
    add: '追加',
    search: '検索',
    reset: 'リセット',
    loading: '読み込み中...',
    noData: 'データがありません',
    error: 'エラー',
    success: '成功',
    warning: '警告',
    close: '閉じる',
    back: '戻る',
    next: '次へ',
    previous: '前へ',
    submit: '送信',
    export: 'エクスポート',
    import: 'インポート',
    refresh: '更新',
    filter: 'フィルター',
    sort: 'ソート',
    select: '選択',
    all: 'すべて',
    none: 'なし',
    yes: 'はい',
    no: 'いいえ',
    enabled: '有効',
    disabled: '無効',
    online: 'オンライン',
    offline: 'オフライン',
    active: 'アクティブ',
    inactive: '非アクティブ',
    status: 'ステータス',
    name: '名前',
    description: '説明',
    type: 'タイプ',
    date: '日付',
    time: '時間',
    createTime: '作成日時',
    updateTime: '更新日時',
    operator: 'オペレーター',
    remark: '備考',
    admin: '管理者',
    company: 'XXX会社',
    system: 'システム',
    currentUser: '現在のユーザー'
  },

  // ホーム関連
  home: {
    title: 'ホーム',
    welcome: 'ようこそ',
    overview: 'システム概要',
    finishEdit: 'home.finishEdit',
    editHome: 'home.editHome',
    saveLayout: 'home.saveLayout',
    addCard: 'home.addCard',
    editCard: 'home.editCard',
    cardTitle: 'home.cardTitle',
    cardDescription: 'home.cardDescription',
    cardType: 'home.cardType',
    cardColor: 'home.cardColor',
    cardIcon: 'home.cardIcon',
    cardSize: 'home.cardSize'
  },

  navigation: {
    title: 'ナビゲーション',
    dashboard: 'ダッシュボード',
    dashboardOverview: 'ダッシュボード概要',
    dashboardPreview: 'ダッシュボードプレビュー',
    dashboardList: 'ダッシュボード一覧',
    dashboardDesign: 'ダッシュボード設計',
    deviceManagement: 'デバイス管理',
    equipmentManagement: '設備管理',
    monitoring: '監視管理',
    applicationManagement: 'アプリケーション管理',
    workflow: 'ワークフロー管理',
    flow: 'フロー管理',
    dataPlatform: 'データ管理',
    microserviceManagement: 'マイクロサービス管理',
    systemManagement: 'システム管理',
    profile: '個人管理',
    notifications: '通知管理',
    alarm: 'アラーム管理',
    alarmManagement: 'アラーム管理',
    deviceMonitoring: 'デバイス監視',
    cctv: 'CCTV監視',
    inspectionManagement: '点検管理',
    inspectionReport: '点検報告',
    permissionManagement: '権限管理',
    userManagement: 'ユーザー管理',
    customDashboard: 'カスタムダッシュボード',
    ruleEngine: 'ルールエンジン',
    home: 'ホーム',
    apiManagement: 'API管理',
    apiInterface: 'インターフェース管理',
    apiModel: 'モデル管理'
  },
  apiManagement: {
    apiInterface: 'インターフェース管理',
    apiModel: 'モデル管理',
    interfaceTab: 'インターフェース管理',
    modelTab: 'モデル管理',
    addApi: 'API追加',
    addModel: 'モデル追加',
    generateLib: 'ライブラリ生成',
    searchInterfaceId: 'インターフェースIDを入力',
    searchInterfacePath: 'インターフェースパスを入力',
    searchModule: 'モジュールIDを入力',
    module: 'モジュールID',
    interfaceId: 'インターフェースID',
    url: 'URL',
    method: 'メソッド',
    createdAt: '作成日時',
    updatedAt: '更新日時',
    action: '操作',
    collectorLabel: 'コレクター',
    selectCollector: 'コレクターを選択',
    gatewayUid: 'ゲートウェイUID',
    selectGateway: 'ゲートウェイを選択',
    moduleDesc: 'モジュール説明',
    selectModule: 'モジュールを選択',
    interfaceIds: 'インターフェースID集合',
    interfaceIdsPlaceholder: '複数のIDはカンマ区切り',
    interval: '間隔'
  },
  dashboard: {
    title: 'ダッシュボード',
    alertSummary: 'アラート作業指示書総数',
    todayNewAlert: '今日の新規アラート数',
    myTodo: '私の未完了',
    processing: '処理中',
    myDone: '私の完了済み',
    inspectionEquipment: '検査設備数',
    unassigned: '未割り当て',
    totalDevices: 'デバイス総数',
    onlineDevices: 'オンラインデバイス',
    offlineDevices: 'オフラインデバイス',
    alertDevices: 'アラートデバイス',
    systemStatus: 'システムステータス',
    performanceMetrics: 'パフォーマンス指標',
    recentAlerts: '最近のアラート',
    deviceStatus: 'デバイスステータス',
    systemHealth: 'システム健全性',
    managementTitle: 'ダッシュボード管理',
    addDashboard: 'ダッシュボード追加',
    batchSetDefault: '一括デフォルト設定',
    preview: 'プレビュー',
    default: 'デフォルト',
    lastModified: '最終更新',
    noDashboards: 'ダッシュボードがありません',
    createFirst: '最初のダッシュボードを作成',
    confirmBatchDelete: '一括削除の確認',
    editDashboard: 'ダッシュボード編集',
    setAsDefault: 'デフォルトに設定',
    fuxaUrl: 'FUXA URL'
  },
  device: {
    title: 'デバイス管理',
    deviceList: 'デバイスリスト',
    subDevice: 'サブデバイス',
    commandManagement: 'コマンド管理',
    addDevice: 'デバイス追加',
    editDevice: 'デバイス編集',
    deviceName: 'デバイス名',
    deviceStatus: 'デバイスステータス',
    deviceType: 'デバイスタイプ',
    deviceModel: 'デバイスモデル',
    deviceId: 'デバイスID',
    nodeId: 'ノードID',
    protocolType: 'プロトコルタイプ',
    mainCircuit: 'メイン回路',
    subCircuit: 'サブ回路',
    commandCount: 'コマンド数',
    lastOnlineTime: '最終オンライン時刻',
    deviceInfo: 'デバイス情報',
    deviceConfig: 'デバイス設定',
    deviceCommands: 'デバイスコマンド',
    deviceHistory: 'デバイス履歴',
    deviceAlerts: 'デバイスアラート',
    deviceMaintenance: 'デバイス保守',
    deviceLocation: 'デバイス位置',
    deviceParameters: 'デバイスパラメータ',
    deviceFirmware: 'デバイスファームウェア',
    deviceNetwork: 'デバイスネットワーク',
    deviceSecurity: 'デバイスセキュリティ',
    deviceListDescription:
      'すべてのデバイスの基本情報、ステータス、設定を表示・管理',

    subDeviceManagement: 'サブデバイス管理',
    subDeviceDescription: 'デバイスのサブデバイスと関連設定を管理',
    commandManagementDescription:
      'デバイスコマンドの送信、履歴確認、実行ステータス表示',

    pendingCommands: '実行待ち',
    deviceStatistics: 'デバイス統計概要',
    totalDeviceCount: '総デバイス数',
    onlineDeviceCount: 'オンラインデバイス',
    offlineDeviceCount: 'オフラインデバイス',
    errorDeviceCount: '故障デバイス',
    nameTooLong: '名前が長すぎます'
  },
  monitoring: {
    title: '監視管理',
    realTimeMonitoring: 'リアルタイム監視',
    alertManagement: 'アラート管理',
    alertHistory: 'アラート履歴',
    alertRules: 'アラートルール',
    alertSettings: 'アラート設定',
    alertLevels: 'アラートレベル',
    alertTypes: 'アラートタイプ',
    alertStatus: 'アラートステータス',
    alertTime: 'アラート時刻',
    alertMessage: 'アラートメッセージ',
    alertSource: 'アラートソース',
    alertHandler: 'アラート処理者',
    alertPriority: 'アラート優先度',
    alertCategory: 'アラートカテゴリ',
    alertSeverity: 'アラート重要度',
    alertAcknowledged: '確認済み',
    alertUnacknowledged: '未確認',
    alertResolved: '解決済み',
    alertPending: '保留中',
    alertProcessing: '処理中'
  },
  workflow: {
    title: 'ワークフロー管理',
    ruleEngine: 'ルールエンジン',
    workflowDesign: 'ワークフロー設計',
    workflowExecution: 'ワークフロー実行',
    workflowHistory: 'ワークフロー履歴',
    workflowTemplates: 'ワークフローテンプレート',
    workflowRules: 'ワークフールール',
    workflowTriggers: 'ワークフロートリガー',
    workflowActions: 'ワークフローアクション',
    workflowConditions: 'ワークフロー条件',
    workflowVariables: 'ワークフロー変数',
    workflowScheduling: 'ワークフロースケジューリング',
    workflowMonitoring: 'ワークフロー監視',
    workflowAnalytics: 'ワークフロー分析',
    workflowOptimization: 'ワークフロー最適化',
    workflowList: 'ワークフローリスト',
    scheduleList: 'スケジュールリスト'
  },
  dataPlatform: {
    title: 'データ管理',
    dashboard: 'データダッシュボード',
    reports: '統計レポート',
    inspectionReport: '検査レポート',
    source: 'データソース管理',
    tasks: 'データタスク',
    dataPlatformMap: 'データプラットフォームマップ',
    dataPlatformMapbox: 'データプラットフォーム Mapbox',
    dataPlatformLineChart: 'データプラットフォーム折れ線グラフ',
    dataPlatformPieChart: 'データプラットフォーム円グラフ'
  },

  application: {
    title: 'アプリケーション管理',
    serviceOverview: 'アプリケーション概要',
    fuxaConfig: 'Fuxa 設定',
    nodeRedConfig: 'Node-RED 設定'
  },

  equipment: {
    title: '設備管理',
    description: 'システム内のすべての設備と関連機能を管理',
    equipmentList: '設備リスト',
    equipmentListDescription:
      'すべての設備の基本情報、ステータス、設定を表示・管理',
    addEquipment: '設備追加',
    editEquipment: '設備編集',
    equipmentDetail: '設備詳細',
    commandManagement: 'コマンド管理',
    batchEdit: '一括編集',
    importModal: 'インポートモジュール'
  },
  flow: {
    title: 'フロー管理',
    description: 'システム内のワークフローとスケジューリングを管理',
    workflowList: 'ワークフローリスト',
    workflowDesign: 'ワークフロー設計',
    scheduleList: 'スケジュールリスト'
  },

  rolePermission: {
    roleList: 'ロールリスト',
    addRole: 'ロール追加',
    editRole: 'ロール編集',
    roleDetail: 'ロール詳細',
    roleName: 'ロール名',
    roleDescription: 'ロール説明',
    rolePermissions: 'ロール権限'
  },
  positionManagement: {
    positionList: '職位リスト',
    addPosition: '職位追加',
    editPosition: '職位編集',
    positionDetail: '職位詳細',
    positionName: '職位名',
    positionDescription: '職位説明'
  },
  organizationManagement: {
    organizationList: '組織リスト',
    addOrganization: '組織追加',
    editOrganization: '組織編集',
    organizationDetail: '組織詳細',
    organizationName: '組織名',
    organizationDescription: '組織説明'
  },

  microservice: {
    pageTitle: 'マイクロサービス管理',
    pageDescription:
      'Dockerコンテナ、Kubernetesサービス、アプリケーションスタックの管理',
    environment: '環境',
    deployStack: 'スタックデプロイ',
    searchPlaceholder: 'コンテナ/スタックを検索...',
    filterByStatus: 'ステータスでフィルター',
    filterByImage: 'イメージでフィルター',

    // コンテナ/スタックプロパティ
    name: '名前',
    image: 'イメージ',
    tag: 'タグ',
    statusLabel: 'ステータス',
    ports: 'ポート',
    cpu: 'CPU',
    memory: 'メモリ',
    resources: 'リソース使用率',
    actions: '操作',
    standalone: 'スタンドアロンコンテナ',

    // ステータス
    status: {
      running: '実行中',
      stopped: '停止中',
      error: 'エラー',
      restarting: '再起動中'
    },

    // 操作ボタン
    start: '開始',
    stop: '停止',
    restart: '再起動',
    logs: 'ログ',
    monitoring: '監視',
    edit: '編集',
    duplicate: '複製',
    delete: '削除',

    // デプロイ関連
    dockerCompose: 'Docker Compose',
    kubernetesYaml: 'Kubernetes YAML',
    uploadFile: 'ファイルアップロード',
    composeContent: 'Compose内容',
    composePlaceholder: 'Docker Compose内容を貼り付け...',
    yamlContent: 'YAML内容',
    yamlPlaceholder: 'Kubernetes YAML内容を貼り付け...',
    selectFile: 'ファイル選択',
    deploy: 'デプロイ',
    deploySuccess: 'デプロイ成功',
    deploySuccessMessage: 'スタックが選択された環境に正常にデプロイされました',
    deployError: 'デプロイエラー',
    deployErrorMessage:
      'デプロイ中にエラーが発生しました。設定を確認してください',

    // ログ関連
    containerLogs: 'コンテナログ',
    autoRefresh: '自動更新',
    downloadLogs: 'ログダウンロード',
    clearLogs: 'ログクリア',

    // 監視関連
    containerMonitoring: 'コンテナ監視',
    cpuUsage: 'CPU使用率',
    memoryUsage: 'メモリ使用率',
    networkIO: 'ネットワークI/O',
    diskIO: 'ディスクI/O',

    // 確認ダイアログ
    confirmDelete: '削除確認',
    deleteWarning:
      'コンテナ「{name}」を削除してもよろしいですか？この操作は元に戻せません。',

    // 環境タイプ
    environmentTypes: {
      docker: 'Docker',
      kubernetes: 'Kubernetes'
    },

    // コンテナタイプ
    containerTypes: {
      container: 'コンテナ',
      stack: 'スタック',
      service: 'サービス'
    },
    serviceOverview: 'サービス概要',
    fuxaConfig: 'FUXA設定',
    nodeRedConfig: 'Node-RED設定'
  },

  deviceMonitoring: {
    title: 'デバイス監視',
    description: 'デバイスの状態とパフォーマンス指標のリアルタイム監視',
    deviceStatus: 'デバイス状態',
    realTimeMetrics: 'リアルタイム指標',
    monitorProperties: '監視プロパティ',
    deviceStatusDescription:
      'すべてのデバイスのリアルタイム状態と基本情報を表示',
    realTimeMetricsDescription:
      'デバイスのリアルタイムパフォーマンス指標とデータを監視',
    monitorPropertiesDescription: '監視プロパティとアラートルールを設定'
  },

  user: {
    title: 'ユーザー管理',
    username: 'ユーザー名',
    password: 'パスワード',
    email: 'メールアドレス',
    phone: '電話番号',
    fullName: '氏名',
    firstName: '名',
    lastName: '姓',
    department: '部署',
    position: '職位',
    role: 'ロール',
    permissions: '権限',
    lastLogin: '最終ログイン',
    loginTime: 'ログイン時刻',
    logoutTime: 'ログアウト時刻',
    loginIp: 'ログインIP',
    userProfile: 'ユーザープロフィール',
    userSettings: 'ユーザー設定',
    userPreferences: 'ユーザー設定',
    userActivity: 'ユーザーアクティビティ',
    userSessions: 'ユーザーセッション',
    systemAdmin: 'システム管理者',
    maintenanceEngineer: '保守エンジニア',
    monitor: '監視員'
  },

  userManagement: {
    userName: 'ユーザー名',
    loginAccount: 'ログインアカウント',
    organization: '所属組織',
    organizationType: '組織タイプ',
    position: '職位',
    role: 'ロール',
    freezeUser: 'ユーザー凍結',
    unfreezeUser: 'ユーザー解凍',
    resetPassword: 'パスワードリセット',
    userList: 'ユーザーリスト',
    userManagement: 'ユーザー管理'
  },
  role: {
    title: 'ロール管理',
    roleName: 'ロール名',
    roleDescription: 'ロール説明',
    rolePermissions: 'ロール権限',
    roleUsers: 'ロールユーザー',
    roleType: 'ロールタイプ',
    roleLevel: 'ロールレベル',
    roleStatus: 'ロールステータス',
    roleCreation: 'ロール作成',
    roleModification: 'ロール変更',
    roleDeletion: 'ロール削除',
    roleAssignment: 'ロール割り当て',
    roleRevocation: 'ロール取り消し',
    roleInheritance: 'ロール継承',
    roleHierarchy: 'ロール階層'
  },
  system: {
    title: 'システム管理',
    globalManagement: 'グローバル管理',
    organizationOverview: '組織概要',
    userManagement: 'ユーザー管理',
    roleManagement: 'ロール管理',
    permissionManagement: '権限管理',
    organizationManagement: '組織管理',
    positionManagement: '職位管理',
    systemConfig: 'システム設定',
    systemLogs: 'システムログ',
    systemBackup: 'システムバックアップ',
    systemRestore: 'システム復元',
    systemUpdate: 'システム更新',
    systemMaintenance: 'システム保守',
    systemSecurity: 'システムセキュリティ',
    systemPerformance: 'システムパフォーマンス',
    systemHealth: 'システム健全性',
    systemMonitoring: 'システム監視',
    rolePermission: 'ロール権限',
    systemSettings: 'システム設定',
    activityLog: 'アクティビティログ',
    serviceLogs: 'サービスログ',
    loginHistory: 'ログイン履歴',
    configService: '設定サービス',
    monitoringAndLogs: '監視とログ'
  },
  organization: {
    title: '組織管理',
    organizationName: '組織名',
    organizationCode: '組織コード',
    organizationType: '組織タイプ',
    organizationLevel: '組織レベル',
    organizationParent: '親組織',
    organizationChildren: '子組織',
    organizationLeader: '組織リーダー',
    organizationContact: '組織連絡先',
    organizationAddress: '組織住所',
    organizationPhone: '組織電話番号',
    organizationEmail: '組織メールアドレス',
    organizationWebsite: '組織ウェブサイト',
    organizationDescription: '組織説明',
    organizationStatus: '組織ステータス',
    organizationCreation: '組織作成',
    organizationModification: '組織変更'
  },
  inspection: {
    title: '検査管理',
    inspectionSchedule: '検査スケジュール',
    inspectionRoute: '検査ルート',
    inspectionReport: '検査レポート',
    inspectionTask: '検査タスク',
    inspectionResult: '検査結果',
    inspectionStatus: '検査ステータス',
    inspectionType: '検査タイプ',
    inspectionFrequency: '検査頻度',
    inspectionDuration: '検査時間',
    inspectionArea: '検査エリア',
    inspectionEquipment: '検査設備',
    inspectionInspector: '検査員',
    inspectionDate: '検査日',
    inspectionTime: '検査時刻',
    inspectionNotes: '検査備考',
    inspectionPhotos: '検査写真',
    inspectionVideos: '検査動画',
    inspectionAlerts: '検査アラート',
    inspectionMaintenance: '検査保守'
  },

  inspectionSchedule: {
    title: '巡検スケジュール',
    routePlanning: 'ルート計画',
    addSchedule: 'スケジュール追加',
    editSchedule: 'スケジュール編集',
    scheduleId: 'スケジュールID',
    time: '時間',
    inspector: '検査員',
    scheduler: 'スケジューラー',
    licensePlateNumber: 'ナンバープレート',
    task: 'タスク',
    inspectionRoute: '検査ルート',
    actions: '操作',
    year: '年',
    month: '月',
    sunday: '日',
    monday: '月',
    tuesday: '火',
    wednesday: '水',
    thursday: '木',
    friday: '金',
    saturday: '土'
  },
  notification: {
    title: '通知管理',
    notificationCenter: '通知センター',
    notificationSettings: '通知設定',
    notificationHistory: '通知履歴',
    notificationTypes: '通知タイプ',
    notificationChannels: '通知チャンネル',
    notificationTemplates: '通知テンプレート',
    notificationRules: '通知ルール',
    notificationScheduling: '通知スケジューリング',
    notificationDelivery: '通知配信',
    notificationStatus: '通知ステータス',
    notificationPriority: '通知優先度',
    notificationRead: '既読',
    notificationUnread: '未読',
    notificationSent: '送信済み',
    notificationFailed: '送信失敗',
    notificationPending: '送信待ち',
    notificationProcessing: '送信中',
    assignedToYou: '作業指示書をあなたに割り当てました'
  },

  notificationCenter: {
    title: '通知センター',
    description: 'システム内のすべての通知メッセージを管理',
    totalNotifications: '総通知数',
    readNotifications: '既読通知',
    unreadNotifications: '未読通知',
    urgentNotifications: '緊急通知',
    addNotification: '通知追加',
    markAllAsRead: 'すべて既読にする',
    deleteReadNotifications: '既読通知を削除',
    status: 'ステータス',
    priority: '優先度',
    keywordSearch: 'キーワード検索',
    filter: 'フィルター',
    notificationDetail: '通知詳細',
    notificationTitle: 'タイトル',
    content: '内容',
    targetUsers: '対象ユーザー',
    createdAt: '作成日時',
    actions: '操作',
    editNotification: '通知編集',
    cancel: 'キャンセル',
    update: '更新',
    add: '追加',
    close: '閉じる',
    titleRequired: 'タイトルは必須です',
    contentRequired: '内容は必須です',
    read: '既読',
    unread: '未読',
    low: '低',
    normal: '通常',
    high: '高',
    urgent: '緊急'
  },
  profile: {
    title: 'プロフィール管理',
    personalProfile: '個人プロフィール',
    personalInfo: '個人情報',
    profileDescription: '他のユーザーは会社と名前であなたを特定できます',
    userName: 'ユーザー名',
    loginAccount: 'ログインアカウント',
    organization: '所属組織',
    organizationType: '組織タイプ',
    department: '部門',
    position: '役職',
    role: '役割',
    gender: '性別',
    genderMale: '男性',
    genderFemale: '女性',
    birthday: '誕生日',
    currentPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    confirmPassword: '新しいパスワードの確認',
    changePassword: 'パスワード変更',
    passwordMismatch: '新しいパスワードと確認パスワードが一致しません',
    interfaceLanguage: 'インターフェース言語',
    systemTimezone: 'システムタイムゾーン',
    traditionalChinese: '繁体中国語',
    english: '英語',
    preferences: '設定',
    savePreferences: '設定を保存',
    resetPassword: 'パスワードリセット',
    accountSettings: 'アカウント設定',
    securitySettings: 'セキュリティ設定',
    notificationPreferences: '通知設定',
    languageSettings: '言語設定',
    themeSettings: 'テーマ設定',
    privacySettings: 'プライバシー設定',
    passwordChange: 'パスワード変更',
    emailVerification: 'メール認証',
    phoneVerification: '電話認証',
    twoFactorAuth: '二要素認証',
    loginHistory: 'ログイン履歴',
    activityLog: 'アクティビティログ',
    dataExport: 'データエクスポート',
    accountDeletion: 'アカウント削除'
  },
  auth: {
    title: '認証',
    login: 'ログイン',
    logout: 'ログアウト',
    register: '登録',
    forgotPassword: 'パスワードを忘れた',
    resetPassword: 'パスワードリセット',
    changePassword: 'パスワード変更',
    verifyEmail: 'メール認証',
    verifyPhone: '電話認証',
    twoFactorSetup: '二要素認証設定',
    rememberMe: 'ログイン状態を保持',
    staySignedIn: 'サインイン状態を保持',
    signInWith: '以下でサインイン',
    createAccount: 'アカウント作成',
    alreadyHaveAccount: '既にアカウントをお持ちですか',
    dontHaveAccount: 'アカウントをお持ちでない場合',
    loginSuccess: 'ログイン成功',
    loginFailed: 'ログイン失敗',
    logoutSuccess: 'ログアウト成功',
    sessionExpired: 'セッション期限切れ',
    unauthorized: '認証されていません',
    forbidden: 'アクセス禁止'
  },
  error: {
    title: 'エラー',
    pageNotFound: 'ページが見つかりません',
    serverError: 'サーバーエラー',
    networkError: 'ネットワークエラー',
    timeoutError: 'タイムアウトエラー',
    validationError: '検証エラー',
    permissionError: '権限エラー',
    authenticationError: '認証エラー',
    authorizationError: '認可エラー',
    resourceNotFound: 'リソースが見つかりません',
    serviceUnavailable: 'サービス利用不可',
    badRequest: '不正なリクエスト',
    forbidden: 'アクセス禁止',
    internalServerError: '内部サーバーエラー',
    gatewayTimeout: 'ゲートウェイタイムアウト',
    tooManyRequests: 'リクエストが多すぎます'
  },
  time: {
    now: '今',
    today: '今日',
    yesterday: '昨日',
    tomorrow: '明日',
    thisWeek: '今週',
    lastWeek: '先週',
    nextWeek: '来週',
    thisMonth: '今月',
    lastMonth: '先月',
    nextMonth: '来月',
    thisYear: '今年',
    lastYear: '去年',
    nextYear: '来年',
    morning: '午前',
    afternoon: '午後',
    evening: '夕方',
    night: '夜',
    seconds: '秒',
    minutes: '分',
    hours: '時間',
    days: '日',
    weeks: '週',
    months: '月',
    years: '年'
  },
  i18n: {
    title: '国際化テスト',
    description: 'これは国際化機能をテストするためのページです',
    welcome: '国際化機能へようこそ',
    language: '言語',
    currentLanguage: '現在の言語',
    changeLanguage: '言語変更',
    languageSettings: '言語設定',
    languageSwitcher: 'languageSwitcher',
    languageCode: 'languageCode',
    languageName: 'languageName',
    currentTime: 'currentTime'
  },
  alarm: {
    title: 'アラーム管理',
    rules: 'アラームルール',
    list: 'アラームリスト',
    templates: 'アラームテンプレート',
    notifications: 'アラーム通知',
    alarmList: 'アラームリスト',
    alarmHistory: 'アラーム履歴',
    alarmRules: 'アラームルール',
    alarmSettings: 'アラーム設定',
    alarmLevels: 'アラームレベル',
    alarmTypes: 'アラームタイプ',
    alarmStatus: 'アラームステータス',
    alarmTime: 'アラーム時刻',
    alarmMessage: 'アラームメッセージ',
    alarmSource: 'アラームソース',
    alarmHandler: 'アラーム処理者',
    alarmPriority: 'アラーム優先度',
    alarmCategory: 'アラームカテゴリ',
    alarmSeverity: 'アラーム重要度',
    alarmAcknowledged: '確認済み',
    alarmUnacknowledged: '未確認',
    alarmResolved: '解決済み',
    alarmPending: '保留中',
    alarmProcessing: '処理中',
    alarmStatistics: 'アラーム統計',
    alarmTrends: 'アラーム傾向',
    alarmReports: 'アラームレポート',
    alarmNotifications: 'アラーム通知',
    alarmEscalation: 'アラームエスカレーション',
    alarmSuppression: 'アラーム抑制',
    alarmCorrelation: 'アラーム相関',
    alarmForecasting: 'アラーム予測',
    alarmOptimization: 'アラーム最適化'
  },

  alarmMessages: {
    title: 'アラームメッセージ',
    description: 'システム内のすべてのアラームメッセージを管理',
    totalAlarms: '総アラーム数',
    unprocessed: '未処理',
    processing: '処理中',
    processed: '処理済み',
    refresh: '更新',
    batchProcess: '一括処理',
    exportReport: 'レポートエクスポート',
    clearProcessed: '処理済みをクリア',
    status: '処理ステータス',
    priority: '優先度',
    deviceType: 'デバイスタイプ',
    keywordSearch: 'キーワード検索',
    filter: 'フィルター',
    alarmDetail: 'アラーム詳細',
    deviceSn: 'デバイスシリアル番号',
    alarmNumber: 'アラーム番号',
    deviceLocation: 'デバイス位置',
    alarmValue: 'アラーム値',
    createTime: '作成時刻',
    updateTime: '更新時刻',
    alarmDescription: 'アラーム説明',
    processNote: '処理備考',
    unknown: '不明',
    noDescription: '説明なし',
    startProcess: '処理開始',
    completeProcess: '処理完了',
    close: '閉じる',
    batchProcessAlarm: 'アラーム一括処理',
    selectAction: '操作選択',
    cancel: 'キャンセル',
    confirm: '確認',
    low: '低',
    normal: '通常',
    high: '高',
    critical: '緊急',
    camera: 'カメラ',
    accessControl: 'アクセス制御',
    sensor: 'センサー',
    controller: 'コントローラー',
    batchMarkProcessing: '一括処理中としてマーク',
    batchMarkProcessed: '一括処理済みとしてマーク',
    batchDelete: '一括削除',
    actions: '操作'
  },

  integratedMonitoring: {
    title: '統合監視センター',
    description:
      'ワンストップ監視管理プラットフォーム - デバイス状態、環境パラメータ、セキュリティアラートの包括的監視',
    totalDevices: 'デバイス総数',
    onlineDevices: 'オンラインデバイス',
    activeAlarms: 'アクティブアラーム',
    todayAlarms: '今日のアラーム',
    unreadNotifications: '未読通知',
    systemHealth: 'システム健全性',
    realtimeAlarms: 'リアルタイムアラーム',
    viewAll: 'すべて表示',
    noAlarms: 'アラームなし',
    deviceStatusDistribution: 'デバイス状態分布',
    environmentMonitoring: '環境監視',
    devicePerformanceTrend: 'デバイス性能トレンド',
    alarmTrendStatistics: 'アラームトレンド統計',
    monitoringDataStorage: '監視データストレージ管理',
    threeModuleIntegration: '3モジュール統合管理',
    monitoringManagement: '監視管理'
  },

  cctv: {
    server: 'サーバー',
    user: 'ユーザー',
    clearSettings: '設定クリア',
    enterModifyUrl: '修正URLを入力してください',
    cancel: 'キャンセル',
    save: '保存'
  },

  customDashboard: {
    editorNotConfigured: 'カスタムダッシュボードエディターが設定されていません',
    serviceNotConfigured: 'カスタムダッシュボードサービスが設定されていません',
    checkEnvironmentVariable:
      '環境変数 VITE_FUXA_HOST が設定されているか確認してください'
  },

  inspectionReport: {
    title: '巡視報告',
    reported: '報告済み',
    notReported: '未報告',
    inspectionId: '巡視ID',
    scheduledTime: '予定時間',
    actualTime: '実際時間',
    inspectionPoint: '巡視ポイント',
    taskContent: 'タスク内容',
    inspectionPersonnel: '巡視担当者',
    status: 'ステータス',
    reportContent: '報告内容',
    attachments: '添付ファイル',
    actions: '操作',
    abnormalId: '異常ID',
    abnormalType: '異常タイプ',
    abnormalContent: '異常内容',
    discoveryLocation: '発見場所',
    discoveredBy: '発見者',
    assignedPersonnel: '担当者',
    discoveryTime: '発見時間',
    completionTime: '完了時間'
  },
  deviceStatus: {
    title: 'デバイスステータス',
    description: 'すべてのデバイスの状態を監視・管理',
    totalDevices: 'デバイス総数',
    onlineDevices: 'オンラインデバイス',
    offlineDevices: 'オフラインデバイス',
    abnormalDevices: '異常デバイス',
    statusDistribution: 'ステータス分布',
    deviceTypeStats: 'デバイスタイプ統計',
    refreshStatus: 'ステータス更新',
    exportReport: 'レポート出力',
    batchActions: '一括操作',
    status: 'ステータス',
    deviceType: 'デバイスタイプ',
    location: '場所',
    deviceNameSn: 'デバイス名/番号',
    applyFilters: 'フィルター適用',
    deviceDetail: 'デバイス詳細',
    deviceName: 'デバイス名',
    deviceSn: 'デバイス番号',
    ipAddress: 'IPアドレス',
    firstOnlineTime: '初回オンライン時刻',
    lastOnlineTime: '最終オンライン時刻',
    deviceDescription: 'デバイス説明',
    noDescription: '説明なし',
    close: '閉じる',
    chooseAction: '操作選択',
    newLocation: '新しい場所',
    cancel: 'キャンセル',
    confirm: '確認',
    actions: '操作',
    online: 'オンライン',
    offline: 'オフライン',
    abnormal: '異常',
    camera: 'カメラ',
    accessControl: 'アクセス制御',
    sensor: 'センサー',
    controller: 'コントローラー',
    floor1Lobby: '1階ロビー',
    floor2Office: '2階オフィス',
    parking: '駐車場',
    serverRoom: 'サーバールーム',
    restart: '再起動',
    updateLocation: '位置更新',
    syncTime: '時刻同期'
  },

  search: {
    placeholder: '機能、ページ、または設定を検索...',
    searching: '検索中...',
    noResults: '結果が見つかりません',
    noResultsDesc:
      '異なるキーワードを試すか、下の一般的な機能を確認してください',
    popularFeatures: '一般的な機能',
    searchTips: '検索のヒント',
    tip1: '「デバイス管理」や「アラーム」などの機能名で検索',
    tip2: 'Ctrl+K (Windows) または Cmd+K (Mac) で素早く検索を開く',
    tip3: '検索結果は関連性に基づいて自動的に並べ替えられます',
    // 新增的 sitemap 相關 key
    frequentlyUsed: 'よく使用する機能',
    fullSitemap: '完全なサイトマップ',
    categoryHome: 'ホーム',
    categoryDashboard: 'ダッシュボード',
    categoryDevicemanagement: 'デバイス管理',
    categoryMonitoring: 'デバイス監視',
    categoryEquipment: '機器管理',
    categoryFlow: 'ワークフロー管理',
    categoryWorkflow: 'ワークフロー管理',
    categoryDataplatform: 'データ管理',
    categoryData: 'データ管理',
    categoryMicroservicemanagement: 'マイクロサービス管理',
    categoryApimanagement: 'API管理',
    categoryInspectionmanagement: '検査管理',
    categoryNotificationmanagement: '通知管理',
    categorySystemmanagement: 'システム管理',
    categorySystem: 'システム管理',
    // 検索結果の説明
    dashboardDesc: 'ダッシュボードの表示と管理',
    dashboardListDesc: 'すべてのダッシュボードリストを閲覧',
    dashboardDesignDesc: 'カスタムダッシュボードの設計と編集',
    deviceMonitoringDesc: 'デバイス状態とパフォーマンスの監視',
    deviceStatusDesc: 'デバイスのリアルタイム状態を表示',
    realTimeMetricsDesc: 'リアルタイムデータメトリクスを表示',
    equipmentManagementDesc: 'デバイスとアセットの管理',
    deviceListDesc: 'デバイスリストを表示',
    flowDesc: 'ワークフローとルールの管理',
    workflowListDesc: 'ワークフローリストを表示',
    dataPlatformDesc: 'データプラットフォームとビジュアライゼーション',
    microserviceDesc: 'マイクロサービス設定の管理',
    apiManagementDesc: 'APIインターフェースとモデルの管理',
    alarmDesc: 'アラームイベントの処理',
    inspectionReportDesc: '検査レポートの表示',
    systemManagementDesc: 'システム設定と管理',
    // 新增缺失的翻譯鍵值
    homeDesc: 'システムホームと概要',
    monitoringDesc: 'デバイス監視と管理',
    devicemanagementDesc: 'デバイス管理と設定',
    dataplatformDesc: 'データプラットフォームとビジュアライゼーション',
    microservicemanagementDesc: 'マイクロサービス管理と設定',
    apimanagementDesc: 'APIインターフェース管理',
    inspectionmanagementDesc: '検査レポート管理',
    notificationmanagementDesc: '通知システム管理',
    systemmanagementDesc: 'システム設定と管理',
    // 子項目描述
    navigationdashboardListDesc: 'すべてのダッシュボードリストを閲覧',
    navigationdashboardDesignDesc: 'カスタムダッシュボードの設計と編集',
    navigationdashboardPreviewDesc: 'ダッシュボード効果のプレビュー',
    deviceMonitoringdeviceStatusDesc: 'デバイスのリアルタイム状態を表示',
    deviceMonitoringrealTimeMetricsDesc: 'リアルタイムデータメトリクスを表示',
    deviceMonitoringmonitorPropertiesDesc: 'デバイスプロパティの監視',
    devicedeviceListDesc: 'デバイスリストを表示',
    devicesubDeviceManagementDesc: 'サブデバイスの管理',
    devicecommandManagementDesc: 'デバイスコマンド管理',
    flowworkflowListDesc: 'ワークフローリストを表示',
    flowworkflowDesignDesc: 'ワークフローの設計',
    flowscheduleListDesc: 'スケジュールリストを表示',
    dataPlatformdataPlatformMapDesc: 'データプラットフォームマップ',
    dataPlatformdataPlatformMapboxDesc: 'データプラットフォーム Mapbox',
    dataPlatformdataPlatformLineChartDesc: 'データプラットフォーム線グラフ',
    dataPlatformdataPlatformPieChartDesc: 'データプラットフォーム円グラフ',
    microserviceserviceOverviewDesc: 'サービス概要',
    microservicefuxaConfigDesc: 'Fuxa 設定',
    microservicenodeRedConfigDesc: 'Node-RED 設定',
    apiManagementapiInterfaceDesc: 'APIインターフェース管理',
    apiManagementapiModelDesc: 'APIモデル管理',
    alarmalarmListDesc: 'アラームリスト',
    inspectionReportreportListDesc: '検査レポートリスト',
    notificationnotificationCenterDesc: '通知センター',
    notificationnotificationSettingsDesc: '通知設定',
    notificationnotificationHistoryDesc: '通知履歴',
    systemglobalManagementDesc: 'グローバル管理',
    systemconfigServiceDesc: '設定サービス',
    systemmonitoringAndLogsDesc: '監視とログ',
    userManagementuserListDesc: 'ユーザー管理',
    rolePermissionroleListDesc: 'ロール権限管理',
    positionManagementpositionListDesc: '職位管理',
    organizationManagementorganizationListDesc: '組織管理',
    systemsystemSettingsDesc: 'システム設定',
    // 其他可能遺漏的翻譯鍵值
    navigationhomeDesc: 'システムホーム',
    navigationdashboardDesc: 'ダッシュボード管理',
    navigationdeviceMonitoringDesc: 'デバイス監視',
    navigationequipmentManagementDesc: '機器管理',
    navigationflowDesc: 'ワークフロー管理',
    navigationdataPlatformDesc: 'データプラットフォーム',
    navigationmicroserviceManagementDesc: 'マイクロサービス管理',
    navigationapiManagementDesc: 'API管理',
    navigationalarmDesc: 'アラーム管理',
    navigationinspectionReportDesc: '検査レポート',
    navigationnotificationsDesc: '通知管理',
    navigationsystemManagementDesc: 'システム管理',
    deviceDesc: 'デバイス管理',
    userManagementDesc: 'ユーザー管理',
    rolePermissionDesc: 'ロール権限',
    positionManagementDesc: '職位管理',
    organizationManagementDesc: '組織管理'
  },

  sidebar: {
    expandAll: 'すべて展開',
    collapseAll: 'すべて折りたたみ'
  },

  footer: {
    termsOfService: '利用規約',
    privacyPolicy: 'プライバシーポリシー'
  }
};
